<template>
  <div class="ci-wrap">
    <el-row :gutter="12">
      <!-- 左侧：分类树 -->
      <el-col :span="4">
        <div class="tree-panel">
          <div class="tree-title">产品分类</div>
          <el-tree
            ref="refTree"
            :props="treeProps"
            :load="loadNode"
            lazy
            node-key="id"
            highlight-current
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ data }" class="tree-node">
              <i :class="data.level >= 4 ? 'el-icon-document' : 'el-icon-folder'"></i>
              {{ data.name }}
            </span>
          </el-tree>
        </div>
      </el-col>

      <!-- 右侧：检验项列表 -->
      <el-col :span="20">
        <div class="list-panel">
          <div class="tabel-bar">
            <div class="tabel-bar-left path-bar">
              <el-breadcrumb v-if="pathNames.length" separator="/">
                <el-breadcrumb-item v-for="(n, i) in pathNames" :key="i">{{ n }}</el-breadcrumb-item>
              </el-breadcrumb>
              <span v-else class="path-empty">全部分类</span>
            </div>
            <div class="tabel-bar-right">
              <el-input
                placeholder="检验项名称"
                :size="$store.state.formSize"
                prefix-icon="el-icon-search"
                v-model="keywords"
                style="width: 180px; margin-right: 8px"
                @input="search"
              ></el-input>
              <el-button
                type="primary"
                :size="$store.state.buttonSize"
                :disabled="!isLeaf"
                :title="isLeaf ? '' : '请先点击左侧末级（第四级）分类'"
                @click="checkItemsPopup()"
                >新增检验项</el-button
              >
              <RemoveButton
                type="info"
                :size="$store.state.buttonSize"
                @click="handleRemoveAll"
                :disabled="!selectionID.length"
                >批量删除</RemoveButton
              >
              <el-tooltip effect="dark" content="刷新列表" placement="bottom">
                <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
              </el-tooltip>
            </div>
          </div>

          <el-table
            ref="refTable"
            v-loading="loading"
            :data="tableData"

            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="checkName" label="检验项名称" width="220"></el-table-column>
            <el-table-column prop="categoryName" label="所属分类" width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="isInitCheckl" label="出厂检验" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isInitCheckl" type="success" size="small">是</el-tag>
                <el-tag v-else type="danger" size="small">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="是否可用" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status !== 0" type="success" size="small">启用</el-tag>
                <el-tag v-else type="info" size="small">停用</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="添加时间" width="250">
              <template slot-scope="scope">{{ scope.row.createTime | format }}</template>
            </el-table-column>
            <el-table-column prop="creatorName" label="添加人" width="90"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="150">
              <template slot-scope="scope">{{ scope.row.updateTime | format }}</template>
            </el-table-column>
            <el-table-column prop="updatorName" label="修改人" width="90"></el-table-column>
            <el-table-column label="操作" width="170" fixed="right">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status !== 0" type="text" @click="statusChange(scope.row)">停用</el-button>
                <el-button v-else type="text" @click="statusChange(scope.row)">启用</el-button>
                <el-button v-if="scope.row.status !== 0" type="text" @click="checkItemsPopup(scope.row.id)">编辑</el-button>
                <el-button type="text" @click="checkItemsDel(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="size"
            :total="total"
          ></pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 检验项表单 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="checkItemsFormVisible" center>
      <el-form
        :model="checkItemsForm"
        :size="$store.state.formSize"
        :rules="checkItemsFormRules"
        ref="refCheckItemsForm"
        label-width="140px"
      >
        <el-form-item label="检验项名称：" prop="checkName">
          <el-input v-model="checkItemsForm.checkName" autocomplete="off"></el-input>
        </el-form-item>

        <!-- 分类固定展示为一行路径：新增取树选中的末级路径、编辑取数据回显，均不可修改 -->
        <el-form-item label="所属分类：">
          <el-input :value="categoryPathText" disabled></el-input>
        </el-form-item>

        <el-form-item label="是否出厂检验：">
          <el-select v-model="checkItemsForm.isInitCheckl" style="width: 100%">
            <el-option v-for="item in options" :key="item.label" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="checkItemsForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getCheckItemsList,
  delCheckItemsList,
  putCheckItemsAdd,
  postCheckItemsEdit,
  postCheckItemsStatus,
  deleteCheckItemsDel,
  getCheckItemsDetail
} from '@/api/checkitems'
import { getCategoryList } from '@/api/category'

const createForm = () => ({
  checkName: '',
  categoryLevel1: '',
  categoryLevel2: '',
  categoryLevel3: '',
  categoryLevel4: '',
  categoryLevelName1: '',
  categoryLevelName2: '',
  categoryLevelName3: '',
  categoryLevelName4: '',
  isInitCheckl: 1,
  remark: ''
})

export default {
  data() {
    return {
      treeProps: { label: 'name', isLeaf: 'isLeaf' },
      tableMaxHeight: 500,
      selectedPath: [], // 当前树选中链路 [{id,name,level}...]
      checkItemsFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      isDisabled: false,
      loading: true,
      selectionID: [],
      tableData: [],
      checkItemsForm: createForm(),
      options: [
        { value: 1, label: '是' },
        { value: 0, label: '否' }
      ],
      checkItemsFormRules: {
        checkName: [{ required: true, message: '请输入检验项名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑检验项' : '新增检验项'
    },
    pathNames() {
      return this.selectedPath.map(n => n.name)
    },
    // 是否选中了末级（第四级）分类
    isLeaf() {
      return this.selectedPath.length >= 4
    },
    // 弹窗内一行只读分类路径：新增取树选中路径，编辑取数据回显
    categoryPathText() {
      if (!this.currentID) {
        return this.pathNames.join(' / ')
      }
      return [
        this.checkItemsForm.categoryLevelName1,
        this.checkItemsForm.categoryLevelName2,
        this.checkItemsForm.categoryLevelName3,
        this.checkItemsForm.categoryLevelName4
      ]
        .filter(Boolean)
        .join(' / ')
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.checkItemsSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 表格体最大高度：面板总高 - 顶部操作栏 - 分页栏，超出部分在表格内部滚动
    calcTableMaxHeight() {
      this.tableMaxHeight = window.innerHeight - 300
    },
    // ========== 左侧分类树 ==========
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.fetchChildren(0, 1, resolve)
      } else if (node.level >= 4) {
        resolve([])
      } else {
        this.fetchChildren(node.data.id, node.level + 1, resolve)
      }
    },
    fetchChildren(pid, level, resolve) {
      getCategoryList(pid)
        .then(res => {
          if (res.status === 1) {
            resolve((res.data || []).map(i => ({ id: i.id, name: i.name, level, isLeaf: level >= 4 })))
          } else {
            resolve([])
          }
        })
        .catch(() => resolve([]))
    },
    handleNodeClick(data, node) {
      const chain = []
      let n = node
      while (n && n.data && n.data.id !== undefined && n.data.id !== null) {
        chain.unshift(n.data)
        n = n.parent
      }
      this.selectedPath = chain
      this.page = 1
      this.getCheckItemsListData()
    },

    // ========== 右侧列表 ==========
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.getCheckItemsListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getCheckItemsListData()
    },
    search() {
      this.page = 1
      this.getCheckItemsListData()
    },
    refresh() {
      this.getCheckItemsListData()
      this.$message.success('数据刷新成功')
    },
    getCheckItemsListData() {
      this.loading = true
      const params = { page: this.page, size: this.size }
      if (this.keywords) {
        params.name = this.keywords
      }
      const levels = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4']
      this.selectedPath.forEach((n, i) => {
        params[levels[i]] = n.id
      })
      getCheckItemsList(params).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
        // 数据渲染后强制重算表格布局，修正 fixed 列位置与滚动条状态
        this.$nextTick(() => {
          if (this.$refs.refTable) this.$refs.refTable.doLayout()
        })
      })
    },

    // ========== 启用/禁用 ==========
    statusChange(row) {
      const target = row.status === 1 ? 0 : 1
      const action = target === 1 ? '启用' : '停用'
      this.$confirm(`确定${action}该检验项吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          postCheckItemsStatus(row.id, target).then(res => {
            if (res.status === 1) {
              this.$message.success(`${action}成功`)
              row.status = target
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {})
    },

    // ========== 删除 ==========
    handleRemoveAll() {
      delCheckItemsList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getCheckItemsListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    checkItemsDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCheckItemsDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除检验项成功')
              this.getCheckItemsListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },

    // ========== 新增/编辑 ==========
    checkItemsPopup(id) {
      const isAdd = !id
      if (isAdd && !this.isLeaf) {
        this.$message.warning('请先点击左侧末级（第四级）分类')
        return
      }
      this.checkItemsFormVisible = true
      this.$set(this, 'checkItemsForm', createForm())

      if (isAdd) {
        this.currentID = null
        // 新增：分类直接取当前树选中的末级路径
        const levels = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4']
        this.selectedPath.forEach((n, i) => {
          this.checkItemsForm[levels[i]] = n.id
          this.checkItemsForm[levels[i] + 'Name'] = n.name
        })
      } else {
        this.isDisabled = true
        this.currentID = id
        getCheckItemsDetail(id).then(res => {
          if (res.status === 1) {
            this.checkItemsForm.checkName = res.data.checkName
            this.checkItemsForm.categoryLevel1 = res.data.categoryLevel1
            this.checkItemsForm.categoryLevel2 = res.data.categoryLevel2
            this.checkItemsForm.categoryLevel3 = res.data.categoryLevel3
            this.checkItemsForm.categoryLevel4 = res.data.categoryLevel4
            this.checkItemsForm.categoryLevelName1 = res.data.categoryLevelName1
            this.checkItemsForm.categoryLevelName2 = res.data.categoryLevelName2
            this.checkItemsForm.categoryLevelName3 = res.data.categoryLevelName3
            this.checkItemsForm.categoryLevelName4 = res.data.categoryLevelName4
            this.checkItemsForm.isInitCheckl = res.data.isInitCheckl
            this.checkItemsForm.remark = res.data.remark
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    checkItemsSubmit() {
      this.$refs.refCheckItemsForm.validate(valid => {
        if (!valid) return false
        const changeCheckItems = this.currentID ? postCheckItemsEdit : putCheckItemsAdd
        changeCheckItems({
          checkName: this.checkItemsForm.checkName,
          categoryLevel1: this.checkItemsForm.categoryLevel1,
          categoryLevel2: this.checkItemsForm.categoryLevel2,
          categoryLevel3: this.checkItemsForm.categoryLevel3,
          categoryLevel4: this.checkItemsForm.categoryLevel4,
          isInitCheckl: this.checkItemsForm.isInitCheckl,
          remark: this.checkItemsForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('编辑检验项成功')
              : this.$message.success('新增检验项成功')
            this.checkItemsFormVisible = false
            this.getCheckItemsListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    hanleResetFormVals() {
      this.checkItemsFormVisible = false
      this.$set(this, 'checkItemsForm', createForm())
      this.$refs.refCheckItemsForm.clearValidate()
    }
  },
  mounted() {
    this.getCheckItemsListData()
    this.calcTableMaxHeight()
    window.addEventListener('resize', this.calcTableMaxHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableMaxHeight)
  },
  filters: {
    format(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ci-wrap {
  .tree-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    // 视口内固定高度，树区域自身滚动（避免整页滚动）
    height: calc(100vh - 180px);
    min-height: 500px;
    padding: 10px;
    display: flex;
    flex-direction: column;

    .tree-title {
      font-weight: bold;
      padding: 4px 6px 10px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 8px;
      flex: none;
    }

    ::v-deep .el-tree {
      flex: 1;
      overflow-y: auto;
    }

    .tree-node i {
      margin-right: 4px;
      color: #409eff;
    }
  }

  .list-panel {
    // 与左侧树等高，内容超出时表格体内部滚动，页面不出整体滚动条
    height: calc(100vh - 180px);
    min-height: 500px;
    display: flex;
    flex-direction: column;

    // 强制表格体可横向滚动：列总宽超出面板宽度时必出横向滚动条
    //（不依赖 el-table 内部 scrollX 判定，其读取 clientWidth 时机异常时会把超出列直接裁剪掉）
    ::v-deep .el-table__body-wrapper {
      overflow-x: auto !important;
    }

    .path-bar {
      display: flex;
      align-items: center;
      min-height: 28px;

      .path-empty {
        color: #909399;
        font-size: 13px;
      }
    }
  }

  .refresh-btn {
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
